(function () {
  document.addEventListener(
    'click',
    function (event) {
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
      var link = null;

      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (el && el.tagName === 'A' && el.href && el.href.indexOf('wa.me') !== -1) {
          link = el;
          break;
        }
        if (el === document || el === window) break;
      }

      if (!link) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'whatsapp_click',
        click_text: (link.textContent || '').trim() || (link.getAttribute('aria-label') || '').trim(),
        click_classes: link.className || '',
        click_url: link.href,
        page_path: window.location.pathname,
      });
    },
    true
  );
})();
